<template>
    <div class="md all">
        <div class="in">
            <div class="caption">{{ caption }}</div><div class="content">{{ content }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            caption: {
                require: false,
                default: '總計'
            },
            content: {
                require: true
            }
        }
    }
</script>

<style scoped lang="scss">

    .md.all {
        padding-right: 50px;
        text-align: right;

        .lo.extend & {
            padding-right: 0;
            margin-top: $interval-s;
        }

        .in {
            display: inline-flex;
        }

        .caption {
            vertical-align: middle;
            padding: $interval-s $interval-m;
            background-color: $light;
            border: $border;
            border-right: 0;
            // border-radius: $border-radius 0 0 $border-radius;
        }

        .content {
            vertical-align: middle;
            padding: $interval-s $interval-m;
            background-color: $white;
            border: $border;
            // border-radius: 0 $border-radius $border-radius 0;
        }
    }
</style>
